import { render, staticRenderFns } from "./Delegations.vue?vue&type=template&id=40b3a22a&scoped=true"
import script from "./Delegations.vue?vue&type=script&lang=js"
export * from "./Delegations.vue?vue&type=script&lang=js"
import style0 from "./Delegations.vue?vue&type=style&index=0&id=40b3a22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3a22a",
  null
  
)

export default component.exports